<template>
                        <!--TREE 공통컴포넌트-->

    <BaseModal ref="baseModalRef" modalId="deptModal" modalNm='부서찾기'>
        <template v-slot:body>
            <div class="table-responsive">
                <div>
                    <div class="border">
                        <Tree
                            ref="treeRef"
                            :menuList="state.treeData"
                            :context-menu="false"
                            :parent-id="'up_dept_cd'"
                            :id="'dept_cd'"
                            :id-nm="'dept_nm'"
                            :root-val="''"
                            @return="r=>getDeptData(r)"
                        />
                    </div>
                </div>
            </div>
        </template>
    
    </BaseModal> 


</template>
    
<script setup>
import {reactive,onBeforeMount,ref} from 'vue'
import Tree from '@/components/common/SettingTree.vue';
import BaseModal from '@/components/common/modal/BaseModal.vue';

import { deptList } from '@/api/dept';
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()

const baseModalRef = ref()
const emits = defineEmits(['return'])

onBeforeMount(async()=> {
    await getDepthList();
})
  

const state = reactive({
    treeData : [],
        dept : {
            dept_cd : '',
            dept_nm : '',
            up_dept_cd : '',
            note : '',
            add_dt : '',
            std_dt : '',
            enable_yn : ''
        },
        selectedRow :[],
})

function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}


//부서 리스트 조회
async function getDepthList(){
    try {
        let param = {
            enable_yn : 'Y'
        }
        setIsLoading(true)
        const res = await deptList(param)

        state.treeData = [...res.rtn]
    } catch (err) {
        alert('부서데이터를 불러오는데 실패했습니다.')
        console.error(err)
    }finally{
        setIsLoading(false)
    }
}

function getDeptData(dept){

    state.selectedRow['dept_cd'] = dept.dept_cd;
    state.selectedRow['dept_nm'] = dept.dept_nm;
    state.selectedRow['up_dept_cd'] = dept.up_dept_cd;

    let deptVal = state.selectedRow  //JSON.stringify(dept) 

    if (dept != null) {
        emits('return',deptVal)
    }else{
        alert('선택된 부서가 없습니다.')
    }
    closeModal()
}

defineExpose({
    openModal,
    closeModal
})
</script>